__turbopack_context__.v({
  "centered": "CIWc4W_centered",
  "container": "CIWc4W_container",
});
